import { render, staticRenderFns } from "./basketballer.vue?vue&type=template&id=4e5f9b54&scoped=true&"
import script from "./basketballer.vue?vue&type=script&lang=js&"
export * from "./basketballer.vue?vue&type=script&lang=js&"
import style0 from "./basketballer.vue?vue&type=style&index=0&id=4e5f9b54&lang=scss&scoped=true&"
import style1 from "./basketballer.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5f9b54",
  null
  
)

export default component.exports